"use strict";
const AnimationDuration = {
  Short: 150,
  Medium: 200,
  Long: 400,
  ExtraLong: 1e3
};
export { AnimationDuration };
